<template>
    <NuxtLayout name="catalog">
        <div class="ware">
            <div class="page-container">
                <MoleculesGlobalBreadcrumb class="my-8" :segments="entity.groups?.sort((a, b) => a.priority - b.priority)?.[0]?.group?.parents"></MoleculesGlobalBreadcrumb>
                <h1 class="mb-8 text-4xl font-secondary">{{ entity.name }}</h1>
                <div class="lg:flex lg:flex-wrap lg:gap-8">
                    <div class="lg:w-1/2 mb-12">

                        <!-- images -->

                        <div v-if="entity.images?.length > 0" class="relative lg:p-8">
                            <div class="text-center">
                                <div v-if="vendorId === 5924305" class="absolute left-0 top-5 text-gray">
                                    <img src="/img/vendors/nubis.png" class="w-[100px] mb-2" />
                                    Výrobce: {{ vendorName }}
                                </div>
                                <div v-else-if="vendorId === 5924309" class="absolute left-0 top-5 text-gray">
                                    <img src="/img/vendors/spikes.jpg" class="w-[100px] mb-2" />
                                    Výrobce: {{ vendorName }}
                                </div>
                                <div v-else-if="vendorId === 6630905" class="absolute left-0 top-5 text-gray">
                                    <img src="/img/vendors/angelic.jpg" class="w-[100px] mb-2" />
                                    Výrobce: {{ vendorName }}
                                </div>
                                <div v-else-if="vendorId === 7190859" class="absolute left-0 top-5 text-gray">
                                    <img src="/img/vendors/marrya.png" class="w-[100px] mb-2" />
                                    Výrobce: {{ vendorName }}
                                </div>
                                <div v-else-if="vendorId === 7313896" class="absolute left-0 top-5 text-gray">
                                    <img src="/img/vendors/swepol.png" class="w-[100px] mb-2" />
                                    Výrobce: {{ vendorName }}
                                </div>
                                <div v-else-if="vendorId === 7190860" class="absolute left-0 top-5 text-gray">
                                    <img src="/img/vendors/nina-sara.png" class="w-[100px] mb-2" />
                                    Výrobce: {{ vendorName }}
                                </div>

                                <div class="absolute right-10 top-5 space-y-2">
                                    <div v-if="totalSale" class="text-conversion text-5xl font-bold">{{ totalSale }}</div>
                                    <div v-if="labels?.length">
                                        <div v-for="item in labels" class="px-4 py-1 bg-conversion text-white font-bold uppercase" :class="`badge--${item.lValue}`">{{ item.value }}</div>
                                    </div>
                                </div>
                                <MoleculesGlobalWareImage :image-id="sortedImages[0].id" :ware-name="sortedImages[0].title" suffix="or" class="mx-auto cursor-pointer" @click="openLightBox(0)" />
                            </div>
                            <div v-if="sortedImages.length > 1" class="mt-8 -mx-2">
                                <carousel :breakpoints="carouselBreakpoints" :itemsToShow="Math.min(3, sortedImages.length)" :itemsToScroll="1">
                                    <slide v-for="(item, index) in sortedImages" :key="slide">
                                        <div class="flex items-center p-2 mx-2 border-2 border-silver transition-all hover:border-conversion cursor-pointer" @click="openLightBox(index)">
                                            <MoleculesGlobalWareImage :image-id="item.id" :ware-name="item.title" suffix="pd" />
                                        </div>
                                    </slide>
                                    <template #addons>
                                    </template>
                                </carousel>
                            </div>

                            <VueEasyLightbox :visible="lightBoxOpened" :index="lightBoxIndexRef" :imgs="lightBoxImages" @hide="closeLightBox" />

                        </div>
                    </div>
                    <div class="relative flex-1">
                        <div class="sticky top-6">
                            <div class="p-8 mb-4 rounded-md shadow-around">
                                <template v-if="isSalable">
                                    <div v-for="(item, index) in panels">
                                        <template v-if="item.variants">
                                            <div v-if="item.name" class="mb-2 text-xl font-bold">{{ item.name }}</div>
                                            <div class="mb-6 text-gray">{{ $t('Kód produktu') }}: {{ item.selectedVariant?.codes?.[0].code ?? utils.findLongestCommonSubstring(item.variants.flatMap(item => item.codes?.[0]?.code)).replace(/-$/, '') }}</div>

                                            <!-- variants -->

                                            <template v-if="item.variants.length > 1">
                                                <div class="mb-4">{{ useUtils().capitalize(item.variants[0].properties?.[0]?.name) }}:
                                                    <AtomsGlobalLink :to="appConfig.definedPageUrls.sizeHelper" target="_blank" class="block lg:inline lg:ml-2 font-bold text-secondary">{{ $t('Jak vybrat tu správnou?') }}</AtomsGlobalLink>
                                                </div>
                                                <div class="ware__variants">
                                                    <button v-for="variant in sortVariants(item.variants)" :title="variant.deliveryPeriod === appConfig.deliveryPeriodNotStored ? $t('Není skladem') : null" :class="{ 'text-gray border-gray bg-silver': variant.deliveryPeriod === appConfig.deliveryPeriodNotStored && variant.id !== item.selectedVariant?.id, 'bg-secondary border-secondary': variant.id === item.selectedVariant?.id }" class="flex justify-center items-center p-3 min-w-[3rem] min-h-[3rem] border-primary border-2 rounded-md transition-all hover:bg-secondary hover:border-secondary" @click="selectVariant(index, variant)" :data-id="variant.id">
                                                        {{ getVariantValue(variant) }}
                                                    </button>
                                                </div>
                                            </template>

                                            <!-- special ring size -->

                                            <template v-if="ringSizesSpecial">
                                                <div class="mb-4">{{ useUtils().capitalize(ringSizesSpecial.name) }}:
                                                    <AtomsGlobalLink :to="appConfig.definedPageUrls.sizeHelper" target="_blank" class="block lg:inline lg:ml-2 font-bold text-secondary">{{ $t('Jak vybrat tu správnou?') }}</AtomsGlobalLink>
                                                </div>
                                                <div class="ware__variants">
                                                    <button v-for="ringSize in ringSizesSpecial.values.sort((a, b) => a.value - b.value)" :class="{ 'bg-secondary border-secondary': isRingSizeSelected(index, ringSize.value) }" class="flex justify-center items-center p-3 min-w-[3rem] min-h-[3rem] border-primary border-2 rounded-md transition-all hover:bg-secondary hover:border-secondary" @click="setRingSize(index, ringSize.value)">
                                                        {{ ringSize.value }}
                                                    </button>
                                                </div>
                                            </template>

                                            <!-- services -->

                                            <div class="mt-2" v-if="areAllSelectedVariantsStored">
                                                <template v-for="service in item.services?.filter(service => service.id && service.id !== OPTIONAL_SERVICE_ID_GRAPHIC && service.id !== OPTIONAL_SERVICE_ID_EXPRESS)">
                                                    <div>
                                                        <label v-if="service.id != MANDATORY_SERVICE_ID" class="inline-flex text-conversion uppercase font-bold leading-5 cursor-pointer">
                                                            <AtomsFormsCheckbox @change="serviceChecked(service, $event)" /> {{ getServiceCheckText(service) }}
                                                        </label>
                                                        <OrganismsPanelsServiceConfiguration v-if="(service.checked || service.id == MANDATORY_SERVICE_ID) && isSelectedVariantStored(item)" :service="service" :max-rows="engravingRows" :max-characters-per-row="engravingCharactersPerRow" @service-selected="service.activeConfiguration = $event; refreshDelivery()" />
                                                    </div>
                                                </template>
                                                <template v-if="isServiceSelected" v-for="service in item.services?.filter(service => service.id === OPTIONAL_SERVICE_ID_GRAPHIC || service.id === OPTIONAL_SERVICE_ID_EXPRESS)" >
                                                    <div v-for="opt in service.options" :key="opt.id">
                                                        <label class="inline-flex text-conversion uppercase font-bold leading-5 cursor-pointer">
                                                        <AtomsFormsCheckbox
                                                            :checked="Array.isArray(service.activeConfiguration) && service.activeConfiguration.includes(opt.id)"
                                                            @change="optionalServiceOptionChecked(service, opt, $event)"
                                                        />
                                                        {{ opt.name }} (+{{ locale.formatPrice(opt.price) }})
                                                        </label>
                                                    </div>
                                                </template>                                               
                                            </div>

                                            <!-- sets separator -->

                                            <div v-if="index < panels.length - 1" class="my-8 border-b-4 border-secondary max-w-[200px]"></div>
                                        </template>
                                    </div>

                                    <template v-if="areAllSelectedVariantsStored">

                                        <!-- total price -->

                                        <div class="mt-4 py-4 text-center lg:text-right"><span class="text-4xl font-bold"><span v-if="totalRecPrice" class="text-gray text-sm line-through p-4">{{ totalRecPrice }}</span>{{ totalPrice }}</span><span class="text-xl"> / {{ entity.unit }} <component v-if="isServiceSelected">včetně služeb</component></span></div>

                                        <!-- availability-->

                                        <div class="py-4 mt-2 border-t-2 border-silver text-center lg:text-right">
                                            <AtomsImagesIcon icon="doprava" size="3xl" class="mr-2" /> <strong>{{ $t('Dostupnost') }}:</strong> {{ deliveryInfo?.text ?? $t('Vyberte variantu') }}
                                        </div>

                                        <!-- add to cart -->

                                        <div class="lg:flex lg:flex-wrap items-center lg:justify-between lg:gap-4">
                                            <div class="my-4 lg:my-0 lg:flex-1 lg:text-center">
                                                <button class="font-secondary text-lg flex gap-2 items-center mx-auto" @click="likedToggle">
                                                    <AtomsImagesIcon icon="oblibene" :class="['mr-2', { 'text-conversion': isLiked }]" />
                                                    <span v-if="!isLiked" class="hover:underline">{{ $t('Přidat do oblíbených') }}</span>
                                                    <span v-if="isLiked" class="hover:underline">{{ $t('Odebrat z oblíbených') }}</span>
                                                </button>
                                            </div>
                                            <MoleculesButtonsButton class="w-full xl:w-auto" :arrow-right="true" :secondary="true" @click="addToCart">{{ $t('Přidat do košíku') }}</MoleculesButtonsButton>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="my-8 border-b-4 border-secondary max-w-[200px]"></div>
                                        <div class="mt-12 mb-4 font-bold">{{ $t('Produkt je vyprodán') }}</div>
                                        {{ $t('Zadejte svůj e-mail a budeme Vás informovat, jakmile bude opět k dispozici:') }}
                                        <MoleculesFormsValidatedField class="mt-4" type="email" v-model="watchdogEmail" :placeholder="$t('Váš e-mail')" :button-text="$t('Odeslat')" :required="true" @submit="setWatchdog" />
                                    </template>
                                </template>
                                <template v-else>
                                    <div class="mb-4 font-bold">{{ $t('Prodej produktu byl ukončen') }}</div>
                                    <template v-if="entity.groups?.length > 0">
                                        {{ $t('Podobné produkty můžete naleznout zde:') }}
                                        <MoleculesGlobalBreadcrumb v-for="item in entity.groups.sort((a, b) => a.priority - b.priority)" class="my-2" :segments="item.group?.parents"></MoleculesGlobalBreadcrumb>
                                    </template>
                                    <template v-else>
                                        <TemplatesNotFound />
                                    </template>
                                </template>

                                <div v-if="materialInfoByParametersAndGroups" class="font-bold text-conversion paragraph-justify py-5">
                                    <span v-html="materialInfoByParametersAndGroups"></span>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mb-8 lg:flex lg:flex-wrap lg:gap-8">
                    <div v-if="entity.description" class="lg:w-1/2">
                        <AtomsTextHeader :type="2" class="header--with-line">{{ $t('Popis') }}</AtomsTextHeader>
                        <div v-html="entity.description" class="text-gray"></div>
                    </div>
                    <div v-if="entity.properties?.filter(item => !mutedParameterIds.includes(item.id)).length > 0" class="flex-1">
                        <AtomsTextHeader :type="2" class="header--with-line">{{ $t('Parametry') }}</AtomsTextHeader>
                        <table class="min-w-[50%]">
                            <tr v-for="item in entity.properties.filter(item => !mutedParameterIds.includes(item.id) && item.values?.some(value => value.value))" class="even:bg-light">
                                <td class="px-4 py-2">{{ item.name }}</td>
                                <td class="px-4 py-2">{{ item.id != appConfig.parameterIds.weight || item.values.length == 1 ? item.values.flatMap(value => value.value).filter((value, index, array) => array.indexOf(value) === index).join(', ') : (panels[0].selectedVariant ? getVariantWeight(panels[0].selectedVariant) : $t('Dle vybrané varianty')) }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div v-if="crossSellItems.length > 0">
                    <AtomsTextHeader :type="3" class="header--with-line">{{ $t('S produktem zákazníci také nakupují') }}</AtomsTextHeader>
                    <OrganismsListsWareList :items="crossSellItems" type="slider" :withSliderPagination="true" list-name="Cross sell - detail produktu"></OrganismsListsWareList>
                </div>

                <!-- featured items -->

                <TemplatesFeaturedItems />

                <!-- magazine -->

                <TemplatesNewestMagazineArticles />

                <!-- recently viewed items -->

                <TemplatesRecentlyViewedItems />

            </div>
        </div>
    </NuxtLayout>
</template>
<script setup>

import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";
import VueEasyLightbox from "vue-easy-lightbox";

import "assets/css/carousel.css";

const entity = useEntity();
const locale = useLocale();
const appConfig = useAppConfig();
const utils = useUtils();
const i18n = useI18n();
const analytics = useAnalytics();
const availability = useAvailability();

const MANDATORY_SERVICE_ID = 9;
const OPTIONAL_SERVICE_ID_GRAPHIC = 10;
const OPTIONAL_SERVICE_ID_EXPRESS = 11;

const mutedParameterIds = [appConfig.parameterIds.engravingRows, appConfig.parameterIds.engravingCharactersPerRow, appConfig.parameterIds.ringServiceDiamonds, appConfig.parameterIds.label];

const panels = ref([]);

//#region images

const sortedImages = computed(() => entity.images?.sort((a, b) => {

    if (a.idsVariants.includes(panels.value[0]?.selectedVariant?.id)) {
        return -1;
    }

    return b.priority - a.priority;
}));


const materialInfoByParametersAndGroups = computed(() => {

    const set = new Set(appConfig.materialDescInfoGroupIds);
    const showMaterialLinks = entity.groups.flatMap(q => q.group).flatMap(q => q.parents).map(q => q.id).some(item => set.has(item));
    const links = entity.properties.flatMap(q=>q.values).map(q=>q.description).filter(q=> q != "");
    return showMaterialLinks && links.length > 0 ? links[0] : null;

});

const getServiceCheckText = (service) => {
  switch (service.id) {
    case 9:
      return i18n.t('chci osazení kamenem');
    case 1:
      return i18n.t('chci přidat rytinu diamantem');
    default:
      return i18n.t('chci přidat rytinu laserem');
  }
};

const lightBoxOpened = ref(false);
const lightBoxIndexRef = ref(0);
const lightBoxImages = computed(() => sortedImages.value?.map((item) => utils.getWareImageUrl(item.id, entity.name, "or")));

const openLightBox = (index) => {
    lightBoxIndexRef.value = index;
    lightBoxOpened.value = true;
}

const refreshDelivery = async () => {
    deliveryInfo.value = await getDeliveryInfo();
}

const closeLightBox = () => lightBoxOpened.value = false;

//#endregion

//#region liked ware

const liked = useLikedWares();
const isLiked = liked.isLiked(entity.id);
const likedToggle = () => liked.toggle(entity.id);

//#endregion

const vendorName = entity.properties?.find(q => q.id === appConfig.parameterIds.vendor)?.values?.[0]?.value;
const vendorId = entity.properties?.find(q => q.id === appConfig.parameterIds.vendor)?.values?.[0]?.lValue;
const engravingRows = entity.properties?.find(q => q.id === appConfig.parameterIds.engravingRows)?.values?.[0]?.value;
const engravingCharactersPerRow = entity.properties?.find(q => q.id === appConfig.parameterIds.engravingCharactersPerRow)?.values?.[0]?.value;
const labels = entity.properties?.filter(item => item.id === appConfig.parameterIds.label).flatMap(item => item.values).map(item => { return { value: item.value, lValue: item.lValue }; });

// append to recently viewed items with delay so this pageload will not push this item directly to the beginning of the list
if (process.client) {
    setTimeout(() => useRecentlyViewedItems().addItem(entity.id), 1000);
}

// sets - multiple panels available
if (entity.sets?.length > 0) {
    panels.value = entity.sets;
}
// single product
else {
    panels.value.push({
        variants: entity.variants,
        services: entity.services
    });
}

const isSalable = entity.sets?.length ? !entity.sets.some(item => !item.variants || item.variants.length === 0) : (entity.variants && entity.variants.length);
const areAllVariantsSelected = computed(() => !panels.value.some(item => !item.selectedVariant));
const isSelectedVariantStored = panel => (panel.selectedVariant?.deliveryPeriod ?? 0) !== appConfig.deliveryPeriodNotStored;
const areAllSelectedVariantsStored = computed(() => !panels.value.some(item => item.selectedVariant?.deliveryPeriod === appConfig.deliveryPeriodNotStored));

const totalSale = computed(() => {
    let result = '';

    if (areAllVariantsSelected.value) {
        let price = 0;
        let priceRec = 0;

        panels.value.forEach(panel => {
            const variantPrice = panel.selectedVariant.prices.price;
            const variantRecPrice = panel.selectedVariant.prices.recommended;

            price += variantPrice;
            priceRec += variantRecPrice;
        });

        result = price < priceRec ? (Math.round(((price / priceRec)-1)* 100) + '%') : null;
    }
    else {
        let minPrice = 0;
        let recPrice = 0;

        panels.value.forEach(item => {
            const variantSales = item.variants?.map(item => ({ perc: item.prices.price / item.prices.recommended, price: item.prices.price, rec: item.prices.recommended }));
            minPrice += variantSales.sort((a, b) => a.perc - b.perc)[0].price;
            recPrice += variantSales.sort((a, b) => a.perc - b.perc)[0].rec;
        });

        result = minPrice < recPrice ? (Math.round(((minPrice / recPrice)-1)* 100) + '%') : null;
    }

    return result;
});

const totalPrice = computed(() => {
    let result = '';

    if (areAllVariantsSelected.value) {

        let price = 0;

        panels.value.forEach(panel => {
            const variantPrice = panel.selectedVariant.prices.price;

            const servicePrices = panel.services
                ?.filter(service => service.checked || service.id == MANDATORY_SERVICE_ID)
                .flatMap(service => getSelectedOptions(service).map(option => option.price));

            const sumOfServicePrices = servicePrices?.reduce((a, b) => a + b, 0) ?? 0;

            price += variantPrice + sumOfServicePrices;
        });

        result = locale.formatPrice(price);
    }
    else {
        let minPrice = 0;
        let maxPrice = 0;

        panels.value.forEach(item => {

            const variantPrices = item.variants?.map(item => item.prices.price);

            minPrice += variantPrices?.sort((a, b) => a - b)[0];
            maxPrice += variantPrices?.sort((a, b) => b - a)[0];

        });
        
        result = minPrice < maxPrice ? i18n.t('od') + ' ' + locale.formatPrice(minPrice) : locale.formatPrice(minPrice);
    }

    return result;
});

const totalRecPrice = computed(() => {
    let result = '';

    if (areAllVariantsSelected.value) {
        let price = 0;
        let priceRec = 0;

        panels.value.forEach(panel => {
            const variantPrice = panel.selectedVariant.prices.price;
            const variantRecPrice = panel.selectedVariant.prices.recommended;

            const servicePrices = panel.services
                ?.filter(service => service.checked || service.id == MANDATORY_SERVICE_ID)
                .flatMap(service => getSelectedOptions(service).map(option => option.price));

            const sumOfServicePrices = servicePrices?.reduce((a, b) => a + b, 0) ?? 0;

            price += variantPrice + sumOfServicePrices;
            priceRec += variantRecPrice + sumOfServicePrices;
        });

        result = price < priceRec ? locale.formatPrice(priceRec) : null;
    }
    else {
        let minPrice = 0;
        let maxPrice = 0;
        let recPrice = 0;

        panels.value.forEach(item => {

            const variantPrices = item.variants?.map(item => item.prices.price);
            const variantRecPrices = item.variants?.map(item => item.prices.recommended);

            minPrice += variantPrices?.sort((a, b) => a - b)[0];
            maxPrice += variantPrices?.sort((a, b) => b - a)[0];
            recPrice += variantRecPrices?.sort((a, b) => b - a)[0];

            if (minPrice < recPrice && minPrice == maxPrice) {
                result = locale.formatPrice(recPrice);
            }
            else {
                result = null;
            }
        });
    }

    return result;
});

const deliveryInfo = ref(null);

const getDeliveryInfo = async () => {
    let result = '';

    if (areAllVariantsSelected.value) {

        const currentLocale = locale.getLocale();
        const countryId = appConfig.orderCountries.find(q => q.localeId === currentLocale.id).id;

        const hypotheticCartItems = panels.value.map(item => {
            return {
                idVariant: item.selectedVariant.id
            };
        });

        const availableShippingLevelsForSelectedVariants = (await useApiFetch(`/api/shippingLevels?countryId=${countryId}&currencyId=${currentLocale.currencyId}&languageId=${currentLocale.languageId}`, {
            method: 'POST',
            body: {
                items: hypotheticCartItems
            }
        })).data.value.shippingLevels;

        let latestDelivery;

        panels.value.forEach(panel => {

            // get fastest shipping option for the selected variant within the panel without own pickup/shipping methods
            const fastestShippingOption = availableShippingLevelsForSelectedVariants.filter(item => !appConfig.ownPickupOrShippingSystemIds.includes(item.shipping.idSystemType)).sort((a, b) => a.estimatedDeliveryDays - b.estimatedDeliveryDays)[0];
            const minShippingDays = fastestShippingOption.estimatedDeliveryDays;

            const serviceDeliveryPeriods = panel.services
                ?.filter(service => service.checked || service.id == MANDATORY_SERVICE_ID)
                .flatMap(service => getSelectedOptions(service).map(option => parseInt(option.delivery)));
            
            const expresService = panel.services?.some(service => Array.isArray(service.activeConfiguration) && service.activeConfiguration.includes(appConfig.serviceOptionIds.expressGravering)) ?? false;

            const sumOfServiceDeliveryPeriods = expresService ? 1 : serviceDeliveryPeriods?.reduce((a, b) => (isNaN(parseInt(a)) ? 0 : a) + (isNaN(parseInt(b)) ? 0 : b), 0) ?? 0;

            const deliveryInfo = availability.getVariantDeliveryInfo(
                entity.deliveryText,
                panel.selectedVariant.deliveryText,
                panel.selectedVariant.storedOnOwnStore,
                panel.selectedVariant.availableCount,
                panel.selectedVariant.deliveryPeriod,
                entity.minNextDelivery,
                appConfig.deadlineHour,
                availability.getFreeDays(),
                parseInt(sumOfServiceDeliveryPeriods),
                minShippingDays
            );

            // get the latest delivery within all selected variants
            if (!latestDelivery || deliveryInfo.deliveryDate > latestDelivery.deliveryDate) {
                latestDelivery = deliveryInfo;
            }
        });

        result = latestDelivery;
    }
    else {
        result = { text: i18n.t('Vyberte varianty obou produktů v páru') };
    }

    return result;
}

const getSelectedOptions = (service) => {
  const activeConfiguration = service.activeConfiguration;

  const selectedOptionIds = Array.isArray(activeConfiguration)
    ? activeConfiguration
    : activeConfiguration?.soId != null
      ? [activeConfiguration.soId]
      : activeConfiguration != null
        ? [activeConfiguration]
        : [];

  return service.options.filter(option => selectedOptionIds.includes(option.id));
};

const selectVariant = async (panelIndex, variant) => {
    const panel = panels.value[panelIndex];

    panel.selectedVariant = variant;

    deliveryInfo.value = await getDeliveryInfo();

    analyticsViewItem(entity, variant);
}

// preselect variant on single variant products
panels.value.forEach((item, index) => {
    if (item.variants?.length === 1) {
        selectVariant(index, item.variants[0]);
    }
});

const analyticsViewItem = async (ware, variant) => {

    const analyticItems = [analytics.getItemDetails(ware, variant)];

    await useFbAPI().registerServerEvent('VIEW_CONTENT', analyticItems);

    analytics.pushEvent('view_item', { ecommerce: { items: analyticItems } });
}

analyticsViewItem(entity);

const isServiceSelected = computed(() => panels.value.some(item => item.services?.some(service => service.id && service.checked && service.id !== OPTIONAL_SERVICE_ID_GRAPHIC && service.id !== OPTIONAL_SERVICE_ID_EXPRESS)));

const serviceChecked = (service, checked) => {
    service.checked = checked;

    if (!service.checked) {
        service.activeConfiguration = null;
    }

    refreshDelivery();
}

const optionalServiceOptionChecked = (service, opt, checked) => {
  if (!Array.isArray(service.activeConfiguration)) {
    service.activeConfiguration = [];
  }

  if (checked) {
    if (!service.activeConfiguration.includes(opt.id)) {
      service.activeConfiguration.push(opt.id);
    }
  } else {
    service.activeConfiguration = service.activeConfiguration.filter(id => id !== opt.id);
  }

  service.checked = service.activeConfiguration.length > 0;

  refreshDelivery();
};

//#region ring size service

const ringSizesSpecial = entity.properties?.find(item => item.id === appConfig.parameterIds.ringSizeSpecial);

const setRingSize = (panelIndex, ringSize) => {
    const panel = panels.value[panelIndex];

    const ringSizeService = panel.services?.find(service => service.activeConfiguration?.soId === appConfig.serviceOptionIds.ringSize);

    if (ringSizeService) {
        ringSizeService.activeConfiguration.f = `${ringSizesSpecial.name}: ${ringSize}`;
    }
    else {

        if (!panel.services) {
            panel.services = [];
        }

        panel.services.push({
            checked: true,
            options: [],
            activeConfiguration: {
                soId: appConfig.serviceOptionIds.ringSize,
                f: `${ringSizesSpecial.name}: ${ringSize}`
            }
        });
    }
}

const isRingSizeSelected = (panelIndex, ringSize) => {
    const panel = panels.value[panelIndex];

    return panel.services?.some(service => service.activeConfiguration?.soId === appConfig.serviceOptionIds.ringSize && service.activeConfiguration?.f === `${ringSizesSpecial.name}: ${ringSize}`);
}

//#endregion

const getVariantValue = (variant) => variant.properties?.[0]?.values[0]?.value;
const getVariantWeight = (variant) => variant.properties?.[1]?.values[0]?.value;

const sortVariants = variants => variants?.sort((a, b) => parseInt(getVariantValue(a)) - parseInt(getVariantValue(b)));

const addToCart = () => {

    if (!areAllVariantsSelected.value) {

        const errorMessage = panels.value.length > 1 ? i18n.t(`Před vložením do košíku je nutné vybrat varianty obou produktů v páru`) : i18n.t(`Před vložením do košíku je nutné vybrat variantu produktu`);

        useMessage().show(errorMessage, null, true, false, i18n.t('Ok'), 5);
    }
    else {

        // single variant product (with possible services)
        if (panels.value.length === 1) {

            const panelServices = getPanelServices(panels.value[0].services);

            useCart().add(
                panels.value[0].selectedVariant.id,
                1,
                panelServices,
                null,
                crossSellItems);
        }
        // set of products (services only for child items)
        else {
            const setProducts = panels.value.map((panel) => {

                const panelServices = getPanelServices(panel.services);

                return {
                    vId: panel.selectedVariant.id,
                    q: 1,
                    s: panelServices,
                }
            });

            useCart().add(entity.variants[0].id, 1, null, setProducts, crossSellItems);
        }
    }
}

const getPanelServices = (services) =>
  services
    ?.filter(service =>
      (service.checked || service.id == MANDATORY_SERVICE_ID) &&
      service.activeConfiguration
    )
    .flatMap(service => {
      if (Array.isArray(service.activeConfiguration)) {
        return service.activeConfiguration.map(optionId => ({
          soId: optionId
        }));
      }

      return [
        JSON.parse(JSON.stringify(service.activeConfiguration))
      ];
    }) || null;

const watchdogEmail = ref('');

const setWatchdog = async () => {
    panels.value.forEach(async item => {
        if (item.selectedVariant && item.selectedVariant?.deliveryPeriod === appConfig.deliveryPeriodNotStored) {
            await useApiFetch(`/api/mutations/watchdog?email=${encodeURIComponent(watchdogEmail.value)}&variantId=${item.selectedVariant.id}&newsletters=true&source=${appConfig.newsletterSubscribeSources.watchdog}&currencyId=${locale.getLocale().currencyId}&languageId=${locale.getLocale().languageId}`);
        }
    });
    watchdogEmail.value = '';

    useMessage().show(i18n.t('E-mail byl pro upozornění na dostupnost byl zaznamenán'), 'ok', false, false, i18n.t('Dobře'), 3);
}

const crossSellItems = await useCrossSell().getItems(entity.linked?.flatMap(item => item.ware), entity.groups);

</script>
<style lang="postcss">
.ware {
    @apply mb-8;

    &__variants {
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
    }
}
</style>